// Catálogo único de Configurações: a página de entrada, as abas de cada seção, a busca e a validação da rota leem daqui.

import { semAcento } from '@alianca/core/shared/texto';

export type SecaoId = 'solar' | 'eletropostos' | 'asaas' | 'clicksign' | 'notificacoes' | 'sinistros' | 'modelos' | 'manutencao' | 'teste';

export interface Aba {
    id: string;
    titulo: string;
}

export interface Secao {
    id: SecaoId;
    grupo: 'Produtos' | 'Integrações' | 'Comunicação com o cliente' | 'Operação' | 'Documentos e sistema';
    titulo: string;
    /** O que há dentro, no cartão da página de entrada. */
    resumo: string;
    /** Subtítulo da página da seção. */
    descricao: string;
    abas: readonly Aba[];
    /** A seção põe as abas onde quer (abaixo da situação) e as esconde quando não se aplicam. */
    abasNoConteudo?: boolean;
    soNoStaging?: boolean;
}

export const SECOES: readonly Secao[] = [
    {
        id: 'solar',
        grupo: 'Produtos',
        titulo: 'Solar',
        resumo: 'Índices de preço, valores por estado, formas de cobrança e validade das propostas.',
        descricao: 'Defina os índices de preço, os valores por estado, a cobrança e a validade das propostas do seguro solar.',
        abas: [
            { id: 'indices', titulo: 'Índices' },
            { id: 'estados', titulo: 'Por estado' },
            { id: 'cobranca', titulo: 'Cobrança' },
            { id: 'propostas', titulo: 'Propostas' },
            { id: 'venda-direta', titulo: 'Venda direta' },
        ],
    },
    {
        id: 'eletropostos',
        grupo: 'Produtos',
        titulo: 'Eletropostos',
        resumo: 'Multiplicadores por pacote, franquias, limites e formas de cobrança.',
        descricao: 'Defina os multiplicadores, as franquias, os limites e a cobrança do seguro de eletropostos.',
        abas: [
            { id: 'pacotes', titulo: 'Pacotes' },
            { id: 'franquias', titulo: 'Franquias e limites' },
            { id: 'estados', titulo: 'Por estado' },
            { id: 'cobranca', titulo: 'Cobrança' },
            { id: 'venda-direta', titulo: 'Venda direta' },
        ],
    },
    {
        id: 'asaas',
        grupo: 'Integrações',
        titulo: 'Asaas',
        resumo: 'Emissão de boletos, Pix e cobranças no cartão. Ambiente e credenciais.',
        descricao: 'Conexão com o Asaas, responsável pelos boletos, pelo Pix e pelas cobranças no cartão dos dois produtos.',
        abas: [],
    },
    {
        id: 'clicksign',
        grupo: 'Integrações',
        titulo: 'Clicksign',
        resumo: 'Assinatura eletrônica dos contratos. Ambientes, token e webhook.',
        descricao: 'Conexão com a Clicksign, responsável pela assinatura eletrônica dos contratos.',
        abas: [],
    },
    {
        id: 'notificacoes',
        grupo: 'Comunicação com o cliente',
        titulo: 'Notificações de cobrança',
        resumo: 'Lembretes antes do vencimento, cobranças de atraso, horário do envio e histórico.',
        descricao: 'Avisos automáticos que lembram o cliente antes do vencimento e cobram as parcelas em atraso.',
        abas: [
            { id: 'avisos', titulo: 'Avisos' },
            { id: 'horario', titulo: 'Horário e ritmo' },
            { id: 'historico', titulo: 'Histórico' },
        ],
        abasNoConteudo: true,
    },
    {
        id: 'sinistros',
        grupo: 'Operação',
        titulo: 'Sinistros',
        resumo: 'Motivos para negar um sinistro.',
        descricao: 'Os motivos que aparecem ao negar um sinistro.',
        abas: [],
    },
    {
        id: 'modelos',
        grupo: 'Documentos e sistema',
        titulo: 'Modelos de contrato',
        resumo: 'Termo de filiação de cada produto e o contrato de parceria.',
        descricao: 'Edite e publique o termo de filiação de cada produto e o contrato de parceria.',
        abas: [],
    },
    {
        id: 'manutencao',
        grupo: 'Documentos e sistema',
        titulo: 'Manutenção',
        resumo: 'Tirar o sistema do ar para todos durante uma manutenção.',
        descricao: 'Tirar o sistema do ar para todos durante uma manutenção.',
        abas: [],
    },
    {
        id: 'teste',
        grupo: 'Documentos e sistema',
        titulo: 'Ambiente de teste',
        resumo: 'Apagar os dados do staging para começar um teste do zero.',
        descricao: 'Ferramentas disponíveis apenas no ambiente de staging.',
        abas: [],
        soNoStaging: true,
    },
];

interface Ajuste {
    titulo: string;
    secao: SecaoId;
    aba?: string;
    /** Palavras que a pessoa pode digitar além do título. */
    termos: string;
}

const AJUSTES: readonly Ajuste[] = [
    { titulo: 'Índice padrão por grupo', secao: 'solar', aba: 'indices', termos: 'grupo preço precificação' },
    { titulo: 'Índices por estado', secao: 'solar', aba: 'estados', termos: 'uf estadual histórico' },
    { titulo: 'Formas de pagamento', secao: 'solar', aba: 'cobranca', termos: 'boleto pix cartão carnê' },
    { titulo: 'Carnê: parcelas e valor mínimo', secao: 'solar', aba: 'cobranca', termos: 'boleto parcela' },
    { titulo: 'Juros e multa após o vencimento', secao: 'solar', aba: 'cobranca', termos: 'atraso' },
    { titulo: 'Validade das propostas', secao: 'solar', aba: 'propostas', termos: 'prazo dias' },
    { titulo: 'Markup na venda direta (Solar)', secao: 'solar', aba: 'venda-direta', termos: 'aliança régua comissão markup' },
    { titulo: 'Markup na venda direta (Eletropostos)', secao: 'eletropostos', aba: 'venda-direta', termos: 'aliança régua comissão markup' },
    { titulo: 'Multiplicador por pacote', secao: 'eletropostos', aba: 'pacotes', termos: 'essencial completo sem parar pessoas rc preço' },
    { titulo: 'Franquias', secao: 'eletropostos', aba: 'franquias', termos: 'franquia alternativa' },
    { titulo: 'Limites e fator de RC', secao: 'eletropostos', aba: 'franquias', termos: 'limite bem cobertura pessoas' },
    { titulo: 'Multiplicadores por estado', secao: 'eletropostos', aba: 'estados', termos: 'uf estadual' },
    { titulo: 'Formas de pagamento', secao: 'eletropostos', aba: 'cobranca', termos: 'boleto pix cartão carnê' },
    { titulo: 'Juros e multa após o vencimento', secao: 'eletropostos', aba: 'cobranca', termos: 'atraso' },
    { titulo: 'Conectar ou reconfigurar o Asaas', secao: 'asaas', termos: 'chave api credencial token pagamento cobrança' },
    { titulo: 'Sandbox ou produção', secao: 'asaas', termos: 'ambiente teste pagamento cobrança' },
    { titulo: 'Webhook de pagamentos', secao: 'asaas', termos: 'webhook avisos token' },
    { titulo: 'Access token e webhook', secao: 'clicksign', termos: 'assinatura credencial ambiente sandbox produção' },
    { titulo: 'Ligar ou desligar o envio de avisos', secao: 'notificacoes', termos: 'notificação cobrança e-mail whatsapp desabilitar' },
    { titulo: 'Sequência de avisos e envio de teste', secao: 'notificacoes', aba: 'avisos', termos: 'régua lembrete atraso vencimento teste' },
    { titulo: 'Horário e ritmo do envio', secao: 'notificacoes', aba: 'horario', termos: 'hora leva pausa lote disparo' },
    { titulo: 'Histórico de avisos enviados', secao: 'notificacoes', aba: 'historico', termos: 'fila falha reenviar notificação' },
    { titulo: 'Motivos de negativa', secao: 'sinistros', termos: 'negar indeferir recusar sinistro motivo' },
    { titulo: 'Termo de filiação', secao: 'modelos', termos: 'modelo contrato documento texto' },
    { titulo: 'Modo manutenção', secao: 'manutencao', termos: 'fora do ar sistema' },
    { titulo: 'Resetar banco de teste', secao: 'teste', termos: 'staging apagar dados' },
];

export interface ResultadoBusca {
    titulo: string;
    caminho: string;
    href: string;
}


export const hrefDaSecao = (secao: SecaoId, aba?: string) => `/configuracoes/${secao}${aba ? `?aba=${aba}` : ''}`;

export function secoesVisiveis(noStaging: boolean): Secao[] {
    return SECOES.filter((s) => !s.soNoStaging || noStaging);
}

export function acharSecao(id: string, noStaging: boolean): Secao | undefined {
    return secoesVisiveis(noStaging).find((s) => s.id === id);
}

/** Ajustes cujo título, termos ou caminho contêm todas as palavras digitadas (sem acento nem caixa). */
export function buscarAjustes(texto: string, noStaging: boolean): ResultadoBusca[] {
    const palavras = semAcento(texto).split(/\s+/).filter(Boolean);
    if (palavras.length === 0) return [];
    return AJUSTES.flatMap((ajuste) => {
        const secao = acharSecao(ajuste.secao, noStaging);
        if (!secao) return [];
        const aba = secao.abas.find((a) => a.id === ajuste.aba);
        const caminho = aba ? `${secao.titulo} › ${aba.titulo}` : secao.titulo;
        const alvo = semAcento(`${ajuste.titulo} ${ajuste.termos} ${caminho}`);
        if (!palavras.every((p) => alvo.includes(p))) return [];
        return [{ titulo: ajuste.titulo, caminho, href: hrefDaSecao(secao.id, aba?.id) }];
    });
}
